/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  JobStatus,
  JobStatusFromJSON,
  JobStatusFromJSONTyped,
  JobStatusToJSON,
} from "./";

/**
 *
 * @export
 * @interface JobStatusControllerResponse
 */
export interface JobStatusControllerResponse {
  /**
   *
   * @type {JobStatus}
   * @memberof JobStatusControllerResponse
   */
  data?: JobStatus;
  /**
   *
   * @type {ErrorResponse}
   * @memberof JobStatusControllerResponse
   */
  error?: ErrorResponse;
}

export function JobStatusControllerResponseFromJSON(json: any): JobStatusControllerResponse {
  return JobStatusControllerResponseFromJSONTyped(json, false);
}

export function JobStatusControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): JobStatusControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : JobStatusFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function JobStatusControllerResponseToJSON(value?: JobStatusControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: JobStatusToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
